"use client";

import React from "react";
import {
  OakBulletList,
  OakUiRoleToken,
  OakFlex,
  OakHeading,
  OakHoverLink,
  OakP,
  OakTagFunctional,
} from "@oaknational/oak-components";
import Link from "next/link";

type Props = {
  backHref: string;
  tagLabel: string;
  headerLeftSlot: React.ReactNode;
  bulletListLabels: string[];
  title?: string;
  subheading?: string;
  description?: string | null;
  color: OakUiRoleToken;
};
export const ListHeader = ({
  backHref,
  tagLabel,
  headerLeftSlot,
  bulletListLabels,
  title,
  subheading,
  description,
  color,
}: Props) => {
  return (
    <OakFlex $flexDirection={"column"} $rowGap={"spacing-32"}>
      <OakFlex $columnGap={"spacing-24"}>
        <OakHoverLink href={backHref} iconName="chevron-left" element={Link}>
          Back
        </OakHoverLink>
        <OakTagFunctional label={tagLabel} $background={color} />
      </OakFlex>
      <OakFlex
        $columnGap={"spacing-32"}
        $flexDirection={["column", "row", "row"]}
        $rowGap={"spacing-24"}
      >
        {headerLeftSlot}
        <OakFlex $flexDirection={"column"} $flexGrow={1} $rowGap={"spacing-16"}>
          <OakBulletList listItems={bulletListLabels} />
          {subheading && (
            <OakHeading tag="h2" $font={["heading-7"]}>
              {subheading}
            </OakHeading>
          )}
          <OakHeading
            tag={"h1"}
            $font={["heading-4", "heading-4", "heading-3"]}
          >
            {title}
          </OakHeading>
          <OakP>{description}</OakP>
        </OakFlex>
      </OakFlex>
    </OakFlex>
  );
};
